import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Footer({ lang, t, onScroll }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === "/";

  const handleFooterNav = (sectionId) => {
    if (isHome && typeof onScroll === "function") {
      onScroll(sectionId);
      return;
    }

    navigate("/");

    window.setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 180);
  };

  return (
    <footer className="aq-footer">
      <div className="aq-container aq-footer-inner">
        <div className="aq-footer-brand">
          <b className="aq-footer-brand-name">Aman-QO</b>
          <div className="aq-muted">
            © {new Date().getFullYear()} {t("footer.rights")}
          </div>
        </div>

        <div className="aq-footer-links">
          <button onClick={() => handleFooterNav("about")} type="button">
            {t("nav.about")}
          </button>

          <button onClick={() => handleFooterNav("founders")} type="button">
            {lang === "ar" ? "الفريق" : "Team"}
          </button>

          <button
            onClick={() => handleFooterNav("achievements")}
            type="button"
          >
            {lang === "ar" ? "الإنجازات" : "Achievements"}
          </button>

          <Link to="/contact-us">
            {lang === "ar" ? "تواصل معنا" : "Contact Us"}
          </Link>

          <Link to="/privacy-policy">
            {lang === "ar" ? "سياسة الخصوصية" : "Privacy Policy"}
          </Link>

          <Link to="/terms-conditions">
            {lang === "ar" ? "الشروط والأحكام" : "Terms & Conditions"}
          </Link>
        </div>

        <div className="aq-footer-socials">
          <a
            href="https://github.com/Aman-Qo"
            target="_blank"
            rel="noreferrer"
            className="aq-footer-social"
            aria-label="GitHub"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 1.5C6.2 1.5 1.5 6.2 1.5 12c0 4.6 3 8.5 7.2 9.9.5.1.7-.2.7-.5v-1.8c-3 .7-3.6-1.3-3.6-1.3-.5-1.2-1.2-1.6-1.2-1.6-1-.7.1-.7.1-.7 1.1.1 1.7 1.2 1.7 1.2 1 .1.8 2.2 3 1.6.1-.7.4-1.1.7-1.4-2.4-.3-4.9-1.2-4.9-5.3 0-1.2.4-2.2 1.1-3-.1-.3-.5-1.4.1-2.9 0 0 .9-.3 3 .1.9-.2 1.9-.4 2.9-.4s2 .1 2.9.4c2.1-.4 3-.1 3-.1.6 1.5.2 2.6.1 2.9.7.8 1.1 1.8 1.1 3 0 4.1-2.5 5-4.9 5.3.4.3.7.9.7 1.9v2.8c0 .3.2.6.7.5 4.2-1.4 7.2-5.3 7.2-9.9C22.5 6.2 17.8 1.5 12 1.5z" />
            </svg>
          </a>

          <a
            href="https://www.linkedin.com/company/aman-qo"
            target="_blank"
            rel="noreferrer"
            className="aq-footer-social"
            aria-label="LinkedIn"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.07c.67-1.2 2.3-2.46 4.73-2.46 5.06 0 6 3.3 6 7.6V24h-5v-6.9c0-1.64-.03-3.75-2.29-3.75-2.29 0-2.64 1.78-2.64 3.63V24h-5V8z" />
            </svg>
          </a>

          <a
            href="https://www.facebook.com/aman.q0"
            target="_blank"
            rel="noreferrer"
            className="aq-footer-social"
            aria-label="Facebook"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2.2V12h2.2V9.8c0-2.2 1.3-3.4 3.3-3.4.96 0 1.97.17 1.97.17v2.2h-1.11c-1.1 0-1.44.68-1.44 1.38V12h2.45l-.39 2.9h-2.06v7A10 10 0 0 0 22 12z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}